export const DEVICE_SETTINGS_POPUP_VALUES = {
    VIBRATIONS_BATTERY_CHARGED: 'VIBRATIONS_BATTERY_CHARGED',
    VIBRATIONS_SMART_HEATING: 'VIBRATIONS_SMART_HEATING',
    VIBRATIONS_ALMOST_FINISHED: 'VIBRATIONS_ALMOST_FINISHED',
    VIBRATIONS_READY_TO_USE: 'VIBRATIONS_READY_TO_USE',
    VIBRATIONS_EXPERIENCE_ENDED: 'VIBRATIONS_EXPERIENCE_ENDED',
    ILLUMINATION_MODE_STRONG: 'ILLUMINATION_MODE_STRONG',
    ILLUMINATION_MODE_LOW: 'ILLUMINATION_MODE_LOW',
    SMART_GESTURES_LIFT_UP: 'SMART_GESTURES_LIFT_UP',
    AUTO_START: 'AUTO_START',
    FLEX_PUFF: 'FLEX_PUFF',
    PAUSE_MODE: 'PAUSE_MODE',
    FLEX_BATTERY_PERFORMANCE_MODE: 'FLEX_BATTERY_PERFORMANCE_MODE',
    FLEX_BATTERY_ECO_MODE: 'FLEX_BATTERY_ECO_MODE',
};
